/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: item-select-select-modal-component.ts
 *
 * Created by kyang on 2019-06-17.
 */

function ItemSelectModalController(this: JS5Object,
                                   _: JS5Object) {
    this.$onInit = () => {
        this.searchText = '';
    };
}

angular
    .module('prism-ui.components')
    .component(
        'itemSelectModal',
        {
            controller: ItemSelectModalController,
            templateUrl: 'components/modal/item-select-modal/item-select-modal-template.html',
            transclude: true,
            bindings: {
                modalTitle: '<',
                selectButtonText: '<',
                loadingIndicator: '=?',
                executeSearch: '&',
                onSearchRefresh: '&?',
                gridIsEmpty: '&',
                onCancelClicked: '&',
                onSelectClicked: '&',
                selectButtonEnabled: '&'
            }
        }
    );
